angular.module("UI8.components").component("softwareFilter", {
  template:
    "<div class='filters__select'>" +
    "  <div class='filters__head'>" +
    "    <div class='filters__label'>{{ $ctrl.label }}</div>" +
    "    <div class='filters__arrow'>" +
    "      <img ng-src='{{$ctrl.activeImageUrl()}}' alt='Select' />" +
    "    </div>" +
    "  </div>" +
    "  <div class='filters__dropdown' ng-class='{isWide: $ctrl.columns > 4, isWider: $ctrl.columns > 9}'>" +
    "    <div class='filters__group'>" +
    "      <button class='filters__btn' ng-repeat='app in $ctrl.softwareFilters track by app.name' ng-click='$ctrl.updateFilter(app.name)' ng-class='$ctrl.isActive(app.name)'>" +
    "        <img ng-src='{{::app.imageUrl}}' ng-alt='{{ ::app.name }}' />" +
    "        <span>{{ $ctrl.displayName(app) }}</span>" +
    "      </button>" +
    "    </div>" +
    "  </div>" +
    "</div>",

  controller: function () {
    var ctrl = this;
    var slug;

    var ANY = "Any Platform"; // stored filter value, displayed as "Any <label>"
    var defaultImageUrl = "/img/app-icons/any-prog.svg";

    // Set here, not in $onInit: Angular runs $onChanges (which fills these)
    // before $onInit, so resetting them there empties the dropdown.
    ctrl.tools = [];
    ctrl.formats = [];
    ctrl.softwareFilters = [];
    ctrl.label = "Platform";

    var filters = (function () {
      var map = {};
      map[ANY] = { name: ANY, imageUrl: defaultImageUrl, kind: "any" };
      var all = (window.UI8 && window.UI8.allCompabilities) || [];
      all.forEach(function (c) {
        map[c.name] = {
          name: c.name,
          imageUrl: c.imageUrl,
          kind: c.kind === "format" ? "format" : "tool",
        };
      });
      return map;
    })();

    function getCurrentFilter() {
      slug = location.pathname.split("/").pop();
      return sessionStorage.getItem(slug + ":category-software-filter") || ANY;
    }

    function byName(a, b) {
      return a.name.localeCompare(b.name);
    }

    // One list: "Any" first, then tools A-Z, then file formats A-Z.
    function setGroups(apps) {
      var tools = apps.filter(function (app) {
        return app.kind === "tool";
      });
      var formats = apps.filter(function (app) {
        return app.kind === "format";
      });
      tools.sort(byName);
      formats.sort(byName);

      ctrl.tools = tools;
      ctrl.formats = formats;
      ctrl.label = tools.length ? "Platform" : "Format";
      ctrl.softwareFilters = [filters[ANY]].concat(tools, formats);
      ctrl.columns = ctrl.softwareFilters.length;
    }

    ctrl.$onInit = function () {
      ctrl.currentFilter = getCurrentFilter();
      ctrl.updateFilter(ctrl.currentFilter);
    };

    ctrl.$onChanges = function () {
      var apps;

      if (ctrl.showApps && ctrl.showApps.length) {
        apps = ctrl.showApps
          .map(function (name) {
            return filters[name];
          })
          .filter(function (app) {
            return !!app;
          });
      } else {
        apps = Object.values(filters).filter(function (app) {
          return app.kind !== "any";
        });
        if (ctrl.limitApps) apps = apps.slice(0, 5);
      }

      setGroups(apps);

      var validFilter = !!ctrl.softwareFilters.filter(function (f) {
        return f.name === ctrl.currentFilter;
      }).length;

      if (!validFilter) ctrl.updateFilter(ANY);
    };

    ctrl.displayName = function (app) {
      return app.name === ANY ? "Any " + ctrl.label : app.name;
    };

    ctrl.updateFilter = function (app) {
      sessionStorage.setItem(slug + ":category-software-filter", app);
      ctrl.currentFilter = app;
      ctrl.onUpdate({ value: app });

      var header = $(".header"),
        trigger = $(".page__trigger"),
        filters = $(".page__filters--sticky");

      if (filters.hasClass("scrolled"))
        window.scroll(0, trigger.offset().top - header.outerHeight());
    };

    ctrl.isActive = function (app) {
      return app === ctrl.currentFilter ? "active" : "";
    };

    ctrl.activeImageUrl = function () {
      var active =
        ctrl.softwareFilters &&
        ctrl.softwareFilters.find(function (f) {
          return f.name === ctrl.currentFilter;
        });
      return active ? active.imageUrl : defaultImageUrl;
    };
  },

  bindings: {
    categoryName: "<",
    showApps: "<?",
    limitApps: "<?",
    onUpdate: "&",
  },
});
